import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private readonly _statusLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly _msgLoader: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

  showLoader(mensagem?: string): void {
    this.putMsgLoader(mensagem);
    this._statusLoader.next(true);
  }

  hideLoader(): void {
    this.putMsgLoader();
    this._statusLoader.next(false);
  }

  get statusLoader(): boolean {
    return this._statusLoader.value;
  }

  putMsgLoader(mensagem?: string): void {
    this._msgLoader.next(mensagem);
  }

  get msgLoader(): string | undefined {
    return this._msgLoader.value;
  }
}
